import { supabase } from './client';
import { getCurrentEmpresaId } from './auth-utils';

export interface FormaPagamento {
  id?: string;
  empresa_id?: string;
  nome: string;
  tipo: 'dinheiro' | 'cartao' | 'pix' | 'boleto' | 'cheque' | 'outro';
  ativa: boolean;
  cor?: string;
  ícone?: string;
  taxa_padrao?: number;
  descricao?: string | null;
  obs_forma_pagamento?: string | null;
  prazo_entrega?: string | null;
  impostos_inclusos?: boolean;
  responsavel?: string | null;
  created_at?: string;
  updated_at?: string;
}

export async function listarFormasPagamento(): Promise<FormaPagamento[]> {
  try {
    const empresaId = await getCurrentEmpresaId();
    if (!empresaId) {
      return [];
    }

    const { data, error } = await supabase
      .from('formas_pagamento')
      .select('*')
      .eq('empresa_id', empresaId)
      .eq('ativa', true)
      .order('nome', { ascending: true });

    if (error) {
      console.error('Erro ao listar formas de pagamento:', error);
      return [];
    }

    return (data || []) as FormaPagamento[];
  } catch (erro) {
    console.error('Erro ao listar formas de pagamento:', erro);
    return [];
  }
}

export async function criarFormaPagamento(forma: Omit<FormaPagamento, 'id' | 'created_at' | 'updated_at' | 'empresa_id'>): Promise<{ ok: boolean; data?: FormaPagamento; error?: string }> {
  try {
    const empresaId = await getCurrentEmpresaId();
    if (!empresaId) {
      return { ok: false, error: 'Usuário não tem empresa associada' };
    }

    const { data, error } = await supabase
      .from('formas_pagamento')
      .insert({
        ...forma,
        empresa_id: empresaId,
        ativa: true,
        taxa_padrao: forma.taxa_padrao || null,
        descricao: forma.descricao || null,
        obs_forma_pagamento: forma.obs_forma_pagamento || null,
        prazo_entrega: forma.prazo_entrega || null,
        impostos_inclusos: forma.impostos_inclusos || false,
        responsavel: forma.responsavel || null,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })
      .select()
      .single();

    if (error) {
      console.error('Erro ao criar forma de pagamento:', error);
      return { ok: false, error: error.message };
    }

    return { ok: true, data: data as FormaPagamento };
  } catch (erro: any) {
    console.error('Erro ao criar forma de pagamento:', erro);
    return { ok: false, error: erro.message || 'Erro ao criar forma de pagamento' };
  }
}

export async function atualizarFormaPagamento(id: string, forma: Partial<FormaPagamento>): Promise<{ ok: boolean; data?: FormaPagamento; error?: string }> {
  try {
    const empresaId = await getCurrentEmpresaId();
    if (!empresaId) {
      return { ok: false, error: 'Usuário não tem empresa associada' };
    }

    const { data, error } = await supabase
      .from('formas_pagamento')
      .update({
        ...forma,
        updated_at: new Date().toISOString()
      })
      .eq('id', id)
      .eq('empresa_id', empresaId)
      .select()
      .single();

    if (error) {
      console.error('Erro ao atualizar forma de pagamento:', error);
      return { ok: false, error: error.message };
    }

    return { ok: true, data: data as FormaPagamento };
  } catch (erro: any) {
    console.error('Erro ao atualizar forma de pagamento:', erro);
    return { ok: false, error: erro.message || 'Erro ao atualizar forma de pagamento' };
  }
}

export async function deletarFormaPagamento(id: string): Promise<{ ok: boolean; error?: string }> {
  try {
    const empresaId = await getCurrentEmpresaId();
    if (!empresaId) {
      return { ok: false, error: 'Usuário não tem empresa associada' };
    }

    const { error } = await supabase
      .from('formas_pagamento')
      .update({ ativa: false, updated_at: new Date().toISOString() })
      .eq('id', id)
      .eq('empresa_id', empresaId);

    if (error) {
      console.error('Erro ao deletar forma de pagamento:', error);
      return { ok: false, error: error.message };
    }

    return { ok: true };
  } catch (erro: any) {
    console.error('Erro ao deletar forma de pagamento:', erro);
    return { ok: false, error: erro.message || 'Erro ao deletar forma de pagamento' };
  }
}
